import { ICrudLocale } from '@app/i18n/interface';

export const EXCHANGE_RATE_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  EXCHANGE_RATE: {
    LABEL: {
      SINGULAR: 'Exchange rate',
      PLURAL: 'Exchange rates',
    },
    FORM: {
      ADD_TITLE: 'Add exchange rate',
      EDIT_TITLE: 'Edit exchange rate',
      CARD_TITLE: 'Exchange rate details',
      BACK: 'Back to Exchange rates',
      ADD_DESCRIPTION: 'Add a currency pair with its rate and margin.',
      EDIT_DESCRIPTION:
        "Update the selected exchange rate's information. The currency pair cannot be changed.",
      FETCH_ERROR: 'Sorry, an error occurred while fetching the exchange rate.',
      SUBMIT_ERROR:
        'Sorry, some errors were detected. Please try again.',
      PAIR_IMMUTABLE_HINT:
        'The base/quote pair is immutable: to change it, create a new exchange rate.',
    },
    APPLIES: {
      TITLE: 'When a rate applies',
      BODY: 'A rate only applies when the provider quotes in a currency other than the sale currency. If it already quotes in the sale currency, nothing is converted, even if the row stays active here.',
      WINDOW: 'Conversions applied · last {{days}} days',
      NONE: 'of the {{priced}} priced rates needed conversion: the provider is quoting in the sale currency, so these rates are not touching any price.',
      SOME: 'of the {{priced}} priced rates needed conversion, so their rate and margin did enter the sale price.',
      NO_DATA: 'No searches measured in this window yet.',
    },
    FIELD: {
      PAIR: 'Pair',
      BASE: 'Base currency (provider)',
      QUOTE: 'Quote currency',
      RATE: 'Mid rate',
      MARGIN_PCT: 'Margin (%)',
      SOURCE: 'Source',
      ACTIVE: 'Active',
      STATE: 'Status',
      UPDATED_AT: 'Updated',
    },
    VALIDATION: {
      CURRENCY_PATTERN: 'Use a 3-letter ISO 4217 code (e.g. EUR).',
      RATE_POSITIVE: 'The rate must be a decimal greater than 0.',
      MARGIN_PATTERN: 'Enter a non-negative decimal (>= 0).',
    },
    REFRESH: {
      ACTION: 'Refresh from the ECB',
      DONE_TITLE: 'Rates updated',
      DONE_TEXT:
        '{{feedDate}} references: {{created}} new pairs and {{updated}} updated.',
      NOOP_TITLE: 'Already up to date',
      NOOP_TEXT:
        'The {{feedDate}} references were already applied: no rate changed.',
      PARTIAL_TITLE: 'Updated with warnings',
      PARTIAL_TEXT:
        '{{feedDate}} references: {{created}} new pairs and {{updated}} updated. Left untouched: {{skipped}}.',
      FAILED_TITLE: 'Could not read the ECB feed',
      FAILED_TEXT:
        'Current rates were not modified. Try again; the daily update retries on its own.',
    },
    LIST: {
      TITLE: 'Currency pairs',
      DESCRIPTION: 'ECB reference rates and their margin. They update by themselves every working day.',
      ADD: 'Add exchange rate',
      CAPTION: 'Exchange rates by currency pair',
      EMPTY: 'There are no exchange rates yet.',
      ACTIVE: 'Active',
      INACTIVE: 'Disabled',
      EDIT: 'Edit',
      EDIT_ARIA: 'Edit pair {{pair}}',
      DISABLE: 'Disable',
      DISABLE_ARIA: 'Disable pair {{pair}}',
      ENABLE: 'Enable',
      ENABLE_ARIA: 'Enable pair {{pair}}',
    },
  },
};
